(function ($) {
    "use strict";

    class PostGridAPI {
        static instance = null;
        defaultArgs = {
            action: "syn_load_more_posts",
            nonce: synPostGrid.nonce,
            post_type: "",
            posts_per_page: 12,
            orderby: "",
            order: "",
            page: 1,
            search: "",
            pre_filtered: false,
        };

        constructor() {
            if (PostGridAPI.instance) {
                return PostGridAPI.instance;
            }

            PostGridAPI.instance = this;
        }

        get(args = {}) {
            const mergedArgs = { ...this.defaultArgs, ...args };

            return $.ajax({
                url: synPostGrid.ajax_url,
                type: "POST",
                data: mergedArgs,
            });
        }
    }

    class PostGridURL {
        static instance = null;
        static queryParamPrefix = "spg_"; // Prefix for query parameters to avoid conflicts with WP core and redirect rules for term archive pages
        static paginationQueryVar = "spg_paged";
        static eventPrefix = "PostGridURL:";
        static originalPathName = '';
        // Map to track segment values by id
        static segmentMap = {};
        // Customize variables that will change per project
        // rootPath will need to set so that the segmentMap knows where to start to build out the url
        // @TODO: Document this

        rootPath = '';

        constructor(rootPath) {
            if (PostGridURL.instance) {
                return PostGridURL.instance;
            }

            this.rootPath = rootPath;

            PostGridURL.instance = this;
        }

        static emit(eventName, data) {
            $(document).trigger(`${PostGridURL.eventPrefix}${eventName}`, [data]);
        }

        get() {
            let url = window.location.href;

            return url;
        }

        getData() {
            return {
                page: this.getPage(),
                queryParams: this.getQueryParams(),
            }
        }

        getPage() {
            const urlObj = new URL(this.get());
            // Primary: pretty /page/{n}/ path segment
            const pathMatch = urlObj.pathname.match(/\/page\/(\d+)\/?$/);
            if (pathMatch) {
                return parseInt(pathMatch[1], 10);
            }
            // Fallback: spg_paged query var (backwards-compatible with older bookmarks)
            const qv = parseInt(urlObj.searchParams.get(PostGridURL.paginationQueryVar), 10);
            return !Number.isNaN(qv) && qv > 0 ? qv : 1;
        }

        getQueryParams() {
            const urlObj = new URL(this.get());
            const params = [];
            urlObj.searchParams.forEach((value, key) => {
                if (
                    key.startsWith(PostGridURL.queryParamPrefix) &&
                    key !== PostGridURL.paginationQueryVar
                ) {
                    params.push({
                        key: key.replace(PostGridURL.queryParamPrefix, ""),
                        value: value
                    });
                }
            });
            return params;
        }

        getQueryParam(key) {
            const params = this.getQueryParams();
            const param = params.find(p => p.key === key);
            return param ? param.value : null;
        }

        paginate(page) {
            const urlObj = new URL(this.get());
            // Remove any existing /page/{n} or trailing spg_paged query var
            urlObj.pathname = urlObj.pathname.replace(/\/page\/\d+\/?$/, "");
            urlObj.searchParams.delete(PostGridURL.paginationQueryVar);
            // Use pretty /page/{n}/ path so URLs look canonical on refresh
            if (page > 1) {
                urlObj.pathname = urlObj.pathname.replace(/\/$/, "") + `/page/${page}/`;
            }
            // Use pushState to add to history instead of replaceState
            window.history.pushState({}, "", urlObj.toString());
            PostGridURL.emit("paginate", urlObj.toString());
            return urlObj.toString();
        }

        clear() {
            const urlObj = new URL(this.get());
            urlObj.pathname = this.rootPath;
            urlObj.search = "";
            window.history.pushState({}, "", urlObj.toString());
            PostGridURL.emit("update", urlObj.toString());
            return urlObj.toString();
        }

        clearPagination() {
            const urlObj = new URL(this.get());
            urlObj.pathname = urlObj.pathname.replace(/\/page\/\d+\/?$/, "");
            urlObj.searchParams.delete(PostGridURL.paginationQueryVar);
            window.history.pushState({}, "", urlObj.toString());
            return urlObj.toString();
        }

        removeQueryParam(key) {
            const urlObj = new URL(this.get());
            urlObj.searchParams.delete(`${PostGridURL.queryParamPrefix}${key}`);
            window.history.pushState({}, "", urlObj.toString());
            PostGridURL.emit("update", urlObj.toString());
            return urlObj.toString();
        }

        updateQueryParam(key, value) {
            if (value === "" || value === null || value === undefined) {
                return this.removeQueryParam(key);
            }
            this.clearPagination();
            const urlObj = new URL(this.get());
            // Retain existing search parameters that do not match the key
            Array.from(urlObj.searchParams.entries()).forEach(([paramKey, paramValue]) => {
                if (paramKey !== `${PostGridURL.queryParamPrefix}${key}`) {
                    urlObj.searchParams.set(paramKey, paramValue);
                }
            });
            urlObj.searchParams.set(`${PostGridURL.queryParamPrefix}${key}`, value);
            // Only update the URL, do not reload the page
            window.history.pushState({}, "", urlObj.toString());
            // Note: popstate will only fire on browser navigation, not on pushState
            PostGridURL.emit("update", urlObj.toString());
            return urlObj.toString();
        }

        // id is used to track where in the url to update the path if it doesnt exist
        updateSegmentPath(id, value) {
            // Use rootPath as the base for building the new path
            let basePath = this.rootPath.replace(/\/$/, "");
            // Update the segmentMap with the new value for the given id

            if (value.includes('>')) {
                value = value.replace(/>/g, '/');
            }

            PostGridURL.segmentMap[id] = value;

            // Build the new path using rootPath and all tracked segments
            let segments = [basePath.replace(/^\//, "")];
            Object.values(PostGridURL.segmentMap).forEach(segment => {
                if (segment) segments.push(segment);
            });

            // Remove any empty segments and join
            let newPath = "/" + segments.filter(Boolean).join("/");

            // Remove any trailing /page/{number} segment
            newPath = newPath.replace(/\/page\/\d+\/?$/, "");

            // Remove any double //
            newPath = newPath.replace(/\/\//g, "/");

            // if path contains categories and path = ''
            if (newPath === '/solutions/partners/categories') {
                newPath = '/solutions/partners';
            }

            // Update the URL
            const urlObj = new URL(this.get());
            urlObj.pathname = newPath;
            window.history.pushState({}, "", urlObj.toString());
            PostGridURL.emit("update", urlObj.toString());
            return urlObj.toString();
        }

        getUrlSegments() {
            const urlObj = new URL(this.get());
            const rootPathSegments = this.rootPath.split("/").filter(Boolean);
            const segments = urlObj.pathname.split("/").filter((part) => {
                // if it is a page segment or is numeric, exit
                if (
                    part === "page" ||
                    !isNaN(part)
                ) {
                    return false;
                }

                return part && !rootPathSegments.includes(part);
            });

            return segments;
        }

        isInUrlSegment(value) {
            const segments = this.getUrlSegments();

            return segments.includes(value);
        }

        isInUrlQuery(value) {
            const params = this.getQueryParams();

            return params.some(param => param.value === value);
        }
    }

    class PostGridPagination {
        eventPrefix = "PostGridPagination:";

        constructor(element, id) {
            this.element = element;
            this.$el = jQuery(element);
            this.id = id;
            this.url = new PostGridURL();
            this.type = "load_more";
            this.maxPages = 0;

            this.init();
            this.listen();
        }

        get page() {
            return this.url.getPage() ?? 1;
        }

        init() {
            // Initialize pagination
        }

        emit(eventName, data) {
            this.$el.trigger(`${this.eventPrefix}${eventName}`, [data]);
        }

        listen() {
            // Event listeners here
            this.$el.on("click", ".syn-post-grid-pagination__trigger", (event) => {
                event.preventDefault();

                this.handleClickLoadMore(event);
            });
        }

        handleClickLoadMore(event) {
            event.preventDefault();

            this.url.paginate(this.page + 1);
        }

        handlePopState(postGridInstance) {
        }

        updateButton() {
            const $button = this.$el.find(".syn-post-grid-pagination__trigger");
            if (this.page >= this.maxPages) {
                $button.hide();
            } else {
                $button.show();
                // Build the next-page pretty URL
                const urlObj = new URL(this.url.get());
                urlObj.pathname = urlObj.pathname.replace(/\/page\/\d+\/?$/, "");
                urlObj.pathname = urlObj.pathname.replace(/\/$/, "") + `/page/${this.page + 1}/`;
                urlObj.searchParams.delete(PostGridURL.paginationQueryVar);
                $button.attr("href", urlObj.toString());
            }
        }
    }

    class PostGridFilter {
        eventPrefix = "PostGridFilter:";

        constructor(element, id) {
            this.element = element;
            this.$el = jQuery(element);
            this.$select = this.$el.find("select");
            this.$search = this.$el.find('input.syn-post-grid-filter__search');
            this.key = this.$el.attr("data-key") || "";
            this.value = this.$select.val() || "";
            this.type = this.$el.attr("data-type") || "";
            this.id = this.$el.attr("id") || "post-grid-filter--" + this.key;
            this.index = this.$select.attr("data-index") || "";
            this.url = new PostGridURL();
            this.urlType = this.$el.attr("data-url-type") || "query";
            this.options = {
                'parent_child_functionality': this.$el.attr("data-parent-child-functionality") || "",
                'update_page_title_description': this.$el.attr("data-update-page-title-description") || ""
            };

            this.init();
            this.listen();
        }

        init() {
            // if the url type is path, we need to set the initial value from the url
            if (this.urlType === 'path') {
                const segments = this.url.getUrlSegments();
                const allSelects = this.$el.find('.syn-post-grid-filter__select');
                
                allSelects.each((i, el) => {
                    jQuery(el).val(segments[i]);
                });
            }

            if (this.$search.length > 0) {
                const value = this.url.getQueryParam(this.key);
                
                if (value) {
                    this.$search.val(value || '');
                    this.$search.addClass('has-value');
                }
            }
        }

        emit(eventName, data) {
            this.$el.trigger(`${this.eventPrefix}${eventName}`, [data]);
        }

        listen() {
            // Event listeners here
            this.$select.on("change", (event) => {
                event.preventDefault();

                this.handleFilterChange(event);
            });

            this.$search.on("keyup", (event) => {
                event.preventDefault();

                if (event.key === "Enter") {
                    this.handleFilterChange(event);
                }
            });

            this.$search.on("change", (event) => {
                event.preventDefault();

                if (this.$search.val() === '') {
                    this.$search.removeClass('has-value');
                } else {
                    this.$search.addClass('has-value');
                }
            });

            this.$search.parent().on("click", '.icon-times', (event) => {
                event.preventDefault();
                this.$search.val('');
                this.$search.removeClass('has-value');
                this.handleFilterChange(event);
                this.url.clear();
            });

            // Listen for child select changes
            this.$el.on("change", '.syn-post-grid-filter__select.child', (event) => {
                event.preventDefault();

                this.handleFilterChange(event);
            });
        }

        clear() {
            this.$select.val('');
            this.$search.val('');
        }

        handleFilterChange(event) {
            // check for children past the one the user changed, if so remove before we calculate the path
            if (
                this.options.parent_child_functionality &&
                this.options.parent_child_functionality === "true"
            ) {
                // check for children past the changing values index and remove them
                const select = event.target;
                const index = $(select).data('index') || 0;
                const allSelects = this.$el.find('.syn-post-grid-filter-input-wrapper');

                allSelects.each((i, el) => {
                    if (i > index) {
                        jQuery(el).remove();
                    }
                });
            }

            // Here we are just updating the url and emitting a custom event for plugins to listen to
            if (this.urlType === 'path') {
                // build out the path based on the selects value
                const allSelects = this.$el.find('.syn-post-grid-filter__select');
                let path = '';

                allSelects.each((i, el) => {
                    const value = jQuery(el).val();
                    if (value) {
                        path += `/${value}`;
                    } else {
                        path = '';
                    }
                });

                this.url.updateSegmentPath(this.id, path);
            } else {
                // build out the query params and update
                const value = this.getValue();
                this.url.updateQueryParam(this.key, value);
            }
        }

        handlePopState() {
            if (this.urlType === 'path') {
                const segments = this.url.getUrlSegments();
                const allSelects = this.$el.find('.syn-post-grid-filter__select');

                if (segments.length) {
                    segments.forEach((segment, index) => {
                        allSelects.eq(index).val(segment);
                    });

                    // check for selects that should not exist anymore based on the url index
                    allSelects.each((i, el) => {
                        if (i > segments.length) {
                            jQuery(el).parent().remove();
                        }
                    });
                } else {
                    // reset the first select to '' and remove the child selects
                    allSelects.eq(0).val('');

                    if (allSelects.length > 1) {
                        allSelects.slice(1).parent().remove();
                    }
                }
            } else {
                // build out the query params and update
                const value = this.url.getQueryParam(this.key);

                if (this.$select.length > 0) {
                    this.$select.val(value || '');
                }

                if (this.$search.length > 0) {
                    this.$search.val(value || '');
                }
            }
        }

        handleLoad(data) {
            if (this.type === "taxonomy") {
                if (this.options.parent_child_functionality) {
                    // do nothing, we dont need to dynamically update filters
                } else {
                    if (
                        data.available_terms?.[this.key] &&
                        !this.url.getQueryParam(this.key)
                    ) {
                        this.filterAvailableTerms(data.available_terms[this.key]);
                    }
                }
            }
        }

        filterAvailableTerms(terms) {
            const options = this.$select.find('option');

            // clear out all of the options
            options.remove();

            // rebuild based on the terms
            this.$select.append(jQuery('<option>', {
                value: '',
                text: 'All'
            }));

            terms.forEach(term => {
                const $option = jQuery('<option>', {
                    value: term.slug,
                    text: term.name
                });

                if (
                    this.url.isInUrlQuery(term.slug) ||
                    this.url.isInUrlSegment(term.slug)
                ) {
                    $option.attr('selected', 'selected');
                }

                this.$select.append($option);
            });
        }

        getValue() {
            let value = this.value;

            if (this.$select.length > 0) {
                if (this.options.parent_child_functionality && this.options.parent_child_functionality === "true") {
                    // if it has children, we need to build out a nested value separated by > of the selects inside
                    const selects = this.$el.find('.syn-post-grid-filter__select');

                    if (selects.length > 1) {
                        value = this.$el.find('.syn-post-grid-filter__select').map(function () {
                            if (jQuery(this).val()) {
                                return jQuery(this).val();
                            }
                        }).get().join(">");
                    } else {
                        value = this.$el.find('.syn-post-grid-filter__select').val();
                    }
                } else {
                    value = this.$select.val();
                }
            }

            if (this.$search.length > 0) {
                value = this.$search.val();
            }

            return value;
        }

        normalizeDataForAPI() {
            const value = this.getValue();

            return {
                filter: this.id,
                type: this.type,
                key: this.key,
                value: value,
                options: this.options
            };
        }

        destroy() {
            this.$el.off("change");
        }

        addChildSelect(childSelect) {
            if (this.options.parent_child_functionality && this.options.parent_child_functionality === "true") {
                // check the last child filter, if the value is '' dont append
                const lastChildValue = this.$el.find('.syn-post-grid-filter-parent-child-wrapper select:last').val();
                if (lastChildValue !== '') {
                    this.$el.find('.syn-post-grid-filter-parent-child-wrapper').append(childSelect);
                }
            } else {
                this.$el.append(childSelect);
            }
        }
    }

    class PostGridFilterCollection {
        eventPrefix = "PostGridFilterCollection:";
        filters = [];
        count = 0;

        constructor() {
            this.element = document.querySelector(".syn-post-grid-filters");
            this.$el = jQuery(this.element);
            this.filters = [];

            this.init();
        }

        init() {
            this.$el.find(".syn-post-grid-filter").each((index, element) => {
                this.create(element);
            });

            this.emit("created", this);
        }

        emit(eventName, data) {
            this.$el.trigger(`${this.eventPrefix}${eventName}`, [data]);
        }

        create(element) {
            this.count++;

            const filter = new PostGridFilter(element, this.count);

            this.add(filter);
        }

        add(filter) {
            if (filter instanceof PostGridFilter) {
                this.filters.push(filter);
            }
        }

        clear() {
            this.filters.forEach((filter) => {
                filter.clear();
            });
        }

        remove(filter) {
            this.filters = this.filters.filter((f) => f !== filter);
        }

        destroy(id) {
            const filter = this.filters.find((f) => f.id === id);
            if (filter) {
                filter.destroy();
                this.remove(filter);
                this.emit("destroyed", { id: id });
            }
        }

        get(index) {
            return this.filters[index];
        }

        getAll() {
            return this.filters;
        }

        getAllValues() {
            return this.filters.map((filter) => filter.getValue());
        }

        normalizeDataForAPI() {
            const data = [];

            this.filters.forEach((filter) => {
                const normalized = filter.normalizeDataForAPI();

                if (normalized) {
                    data.push(normalized);
                }
            });

            return data;
        }

        handlePopState(event) {
            this.filters.forEach((filter) => {
                filter.handlePopState(event);
            });
        }

        handleLoad(data) {
            this.filters.forEach((filter) => {
                filter.handleLoad(data);
            });
        }
    }

    /**
     * PostGrid Class
     *
     * This class manages the post grid functionality, including loading posts,
     * handling filters, and managing the grid state.
     *
     * @class PostGrid
     * @property {string} eventPrefix - Prefix for custom events.
     * @property {HTMLElement} element - The DOM element for the post grid.
     * @property {jQuery} $el - jQuery object for the post grid element.
     * @property {jQuery} $gridItems - jQuery object for the grid items container.
     * @property {string} id - Unique identifier for the post grid instance.
     * @property {PostGridAPI} api - Instance of PostGridAPI for AJAX requests.
     * @property {PostGridURL} url - Instance of PostGridURL for URL management.
     * @property {PostGridFilterCollection} filters - Collection of filters applied to the post grid.
     *
     * @event PostGrid:created - Triggered when a new PostGrid instance is created.
     * @event PostGrid:dataChanged - Triggered when the data attributes of the post grid changes.
     * @event PostGrid:loadMore - Triggered when the "Load More" button is clicked before loading more posts.
     */
    class PostGrid {
        eventPrefix = "PostGrid:";

        constructor(element, id) {
            this.element = element;
            this.$el = jQuery(element);
            this.$form = this.$el.find("form");
            this.id = this.$el.attr("id") || "post-grid-" + id;
            this.$gridItems = this.$el.find(".syn-post-grid-items");
            this.api = new PostGridAPI();
            this.rootPath = this.$el.data("root-path") || "";
            this.url = new PostGridURL(this.rootPath);
            this.filters = new PostGridFilterCollection();
            this.pagination = new PostGridPagination(this.$el.find(".syn-post-grid-pagination"), this.id);
            this.options = {};

            this.init();
            this.listen();
        }

        get data() {
            return {
                id: this.id,
                baseUrl: this.$el.data("base-url") || "",
                postType: this.$el.data("post-type"),
                postsPerPage: this.$el.data("posts-per-page"),
                orderby: this.$el.data("orderby"),
                order: this.$el.data("order"),
                page: this.$el.data("page"),
                maxPages: this.$el.data("max-pages"),
                preFiltered: this.$el.data("pre-filtered") || false,
                queriedObjectTaxonomy: this.$el.data("queried-object-taxonomy") || "",
                queriedObjectTerm: this.$el.data("queried-object-term") || "",
                filters: this.filters.normalizeDataForAPI() || [],
                taxonomyRelation: this.$el.data("taxonomy-relation") || "AND",
                noResultsText: this.$el.data("no-results-text") || "No posts found."
            };
        }

        set data(newData) {
            if (typeof newData === "object") {
                for (const key in newData) {
                    let hyphenCaseKey = this.toHyphenCase(key);

                    if (this.$el.data(hyphenCaseKey) !== undefined) {
                        this.$el.data(hyphenCaseKey, newData[key]);
                        this.$el.attr(`data-${hyphenCaseKey}`, newData[key]);

                        this.emit("dataChanged", {
                            key: key,
                            value: newData[key],
                        });
                    }
                }
            } else {
                console.error("Data must be an object { key: value }");
            }
        }

        normalizeDataForAPI(opts = { emptyPosts: false }) {
            let urlData = this.url.getData(); // may need to check for filter keys here and call each filters normalize method to build
            let filterData = this.filters.normalizeDataForAPI();

            this.data = {
                page: this.pagination.page,
                filters: urlData.queryParams,
            };

            // If we are emptying the post grid, we need to increase to posts_per_page
            return {
                post_type: this.data.postType,
                posts_per_page: opts.emptyPosts ? (this.data.page * this.data.postsPerPage) : this.data.postsPerPage,
                orderby: this.data.orderby,
                order: this.data.order,
                page: opts.emptyPosts ? 1 : this.data.page,
                max_pages: this.data.maxPages,
                pre_filtered: this.data.preFiltered,
                queried_object_taxonomy: this.data.queriedObjectTaxonomy,
                queried_object_term: this.data.queriedObjectTerm,
                options: this.options,
                filters: filterData,
                taxonomy_relation: this.data.taxonomyRelation,
                no_results_text: this.data.noResultsText
            };
        }

        init() {
            this.emit("created", this);

            // Check initially if the load more button should be hidden
            if (this.shouldHideLoadMoreButton()) {
                this.$el.find(".syn-post-grid-load-more").hide();
            }
        }

        emit(eventName, data) {
            this.$el.trigger(`${this.eventPrefix}${eventName}`, [data]);
        }

        listen() {
            // Event listeners here
            // TODO: Add a pagination class to handle this
            // this.$el.on("click", ".syn-post-grid-load-more", (event) => {
            //     event.preventDefault();

            //     this.emit("loadMore", this);
            //     this.handleClickLoadMore(event);
            // });

            this.$form.on("submit", (event) => {
                event.preventDefault();
            });

            $(window).on("popstate", (event) => {
                this.handlePopState(event);
            });

            // This event happens after the url has been updated with either path or query params
            $(document).on("PostGridURL:update", (event, data) => {
                event.preventDefault();

                this.handlePopState(event);
            });

            // This event happens after the url has been updated for pagination, big difference is it should only append posts
            $(document).on("PostGridURL:paginate", (event, data) => {
                event.preventDefault();

                this.handlePaginate(event);
            });

            this.$el.on('click', '.syn-post-grid-action--clear-filters', (event) => {
                event.preventDefault();

                this.filters.clear();
                this.url.clear();
            })
        }

        handleClickLoadMore() {
            const nextPage = parseInt(this.$el.data("page"), 10) + 1;
            const maxPages = parseInt(this.$el.data("max-pages"), 10);

            if (nextPage <= maxPages) {
                this.data = { 'page': nextPage };

                this.url.paginate(nextPage);

                this.loadFilteredPosts();
            }
        }

        handlePopState(event) {
            event.preventDefault();

            this.filters.handlePopState();
            this.pagination.handlePopState();

            this.loadFilteredPosts({ emptyPosts: true });
        }

        handlePaginate(event) {
            event.preventDefault();

            this.filters.handlePopState();
            this.pagination.handlePopState();

            this.loadFilteredPosts({ emptyPosts: false });
        }

        /**
         * Asynchronously loads filtered posts into the grid, optionally clearing existing posts.
         * Handles API response, updates grid items, pagination, and load more button visibility.
         * Also updates child term filters if provided in the response.
         *
         * @async
         * @param {Object} [opts={}] - Options for loading posts.
         * @param {boolean} [opts.emptyPosts=false] - Whether to clear existing posts before loading new ones.
         * @returns {Promise<void>} Resolves when posts are loaded and UI is updated.
         */
        async loadFilteredPosts(opts = { emptyPosts: false }) {
            try {
                this.$el.trigger('loader:show');

                let payload = this.normalizeDataForAPI(opts);
                const response = await this.api.get(payload);

                // Handle successful response
                if (response.success && response.data.html) {
                    if (opts.emptyPosts) {
                        // Clear existing posts if emptyPosts is true
                        this.$gridItems.empty();
                    }

                    this.filters.handleLoad(response.data);

                    // Append new posts
                    this.$gridItems.append(response.data.html);

                    // Check if there are any posts and add/remove the no-results class
                    const items = this.$gridItems.find('.syn-post-grid-item');

                    if (items.length > 0) {
                        this.$gridItems.removeClass('syn-post-grid-no-results');
                    } else {
                        this.$gridItems.addClass('syn-post-grid-no-results');
                    }

                    // Update the page data attribute
                    this.$el.data("page", response.page);
                    this.$el.attr("data-page", response.page);
                    this.$el.data("max-pages", response.data.max_pages);
                    this.$el.attr("data-max-pages", response.data.max_pages);

                    this.pagination.maxPages = response.data.max_pages;
                    this.pagination.updateButton();

                    // Check to see the response contains any additional feature options
                    // Might want to break this part out in the future
                    if (response.data.child_terms) {
                        this.filters.get(0).addChildSelect(response.data.child_terms);
                    }

                    // If the response data has page_title and page_description in it for the filters update_page_title_and_description option, attempt to update the pages content
                    if (response.data.page_title) {
                        this.updatePageTitleDescription(response.data);
                    }
                } else {
                    console.error("Error in load more response:", response);
                }

                this.$el.trigger('loader:hide');
            } catch (error) {
                // Handle error
                console.error(error);
                window.alert("An error occurred while loading posts.");
            }
        }

        updatePageTitleDescription(data) {
            // this code is assuming that the page title and description are the first component on the page
            const wrapper = document.querySelector('main .wrapper.flex:first-of-type');

            let title = wrapper.querySelector('h1');
            let description = wrapper.querySelector('.text-content');

            if (!description) {
                description = wrapper.querySelector('h1 ~ p');
            }

            if (title) {
                title.textContent = data.page_title;
            }

            if (description) {
                description.textContent = data.page_description;
            }

            if (data.page_seo_title) {
                let seo_title = data.page_seo_title;

                seo_title = seo_title.replace('%max_pages%', data.max_pages);
                document.title = seo_title;
            }

            if (data.page_seo_description) {
                let seo_description = data.page_seo_description;

                const descriptionMeta = document.querySelector('meta[name="description"]');
                if (descriptionMeta) {
                    descriptionMeta.setAttribute("content", seo_description);
                }
            }
        }

        shouldHideLoadMoreButton() {
            const currentPage = parseInt(this.$el.data("page"), 10);
            const maxPages = parseInt(this.$el.data("max-pages"), 10);
            return currentPage >= maxPages;
        }

        toSnakeCase(str) {
            return str
                .replace(/([a-z])([A-Z])/g, "$1_$2")
                .replace(/[\s-]+/g, "-")
                .toLowerCase();
        }

        toHyphenCase(str) {
            return str
                .replace(/([a-z])([A-Z])/g, "$1-$2")
                .replace(/[\s_]+/g, "-")
                .toLowerCase();
        }
    }

    class PostGridFactory {
        static collection = [];
        static count = 0;

        static create(element) {
            this.count++;
            const instance = new PostGrid(element, this.count);
            this.collection.push(instance);
            return instance;
        }

        static getAll() {
            return this.collection;
        }

        static getById(id) {
            return this.collection.find((instance) => instance.id === id);
        }

        static getByIndex(index) {
            return this.collection[index] || null;
        }
    }

    $(document).ready(function () {
        // Initialize PostGrid instances
        $(".syn-post-grid").each(function () {
            PostGridFactory.create(this);

            // Customization for DPT Sort By Button interface.
            $(this).on("click", ".sort-buttons button", (e) => {
                e.preventDefault();

                const $button = $(e.target);
                const value = $button.data("sort-value");

                // Find the select above and change
                const select = $button.closest(this).find("#syn-post-grid-filter-select--sort");
                select.val(value).trigger("change");

                // Update active class
                $button.siblings().removeClass("active");
                $button.addClass("active");
            });
        });

    });
})(jQuery);